import { BaseResponse, PageQueryParams } from '../../../../../../types/api/api.types';
import { SearchProspectsFromCOMResponse } from '../../../../../../types/api/endpoints/prospect/prospect.types';
import { PROSPECT_ENDPOINTS } from '../../../../../../utils/api/endpoints/prospectEndpoints';
import { UpdateProspectStatusQueryParams } from './DashboardProspectsCOMTable.types';

const UPDATE_PREFIX = '[updateProspectStatusQuery]';

export const UPDATE_PROSPECT_STATUS_QUERY_KEY = 'UPDATE_PROSPECT_STATUS';

export const updateProspectStatusQuery = async (params: UpdateProspectStatusQueryParams) => {
  console.log(UPDATE_PREFIX, `Updating prospect status...`);
  const response = await PROSPECT_ENDPOINTS.updateStatus(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(UPDATE_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(UPDATE_PREFIX, `Updated prospect status.`);
  return json as BaseResponse;
};

// const SEARCH_PREFIX = '[searchProspectQuery]'

// export const SEARCH_PROSPECT_STATUS_QUERY_KEY = 'SEARCH_PROSPECT'

// export const searchCurrentCOMProspectsQuery = async (search: string) => {
//   console.log(SEARCH_PREFIX, `Fetching search prospects...`);
//   const response = await PROSPECT_ENDPOINTS.searchCurrentCOM(search);

//   const { ok, data: json } = response;

//   if (!ok) {
//     const error = response.data;
//     console.log(SEARCH_PREFIX, 'An error occurred.', error);
//     throw error;
//   }

//   console.log(SEARCH_PREFIX, `Fetched search prospects.`);
//   return json as SearchProspectsResponse;
// }

const SEARCH_PREFIX = '[searchProspectFromCOMQuery]';

export const SEARCH_PROSPECT_QUERY_KEY = 'SEARCH_PROSPECT';

export const searchProspectFromCOMQuery = async (search: string, params: PageQueryParams) => {
  console.log(SEARCH_PREFIX, `Fetching search prospects...`);
  const response = await PROSPECT_ENDPOINTS.searchFromCOM(search, params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(SEARCH_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(SEARCH_PREFIX, `Fetched search prospects.`);
  return json as SearchProspectsFromCOMResponse;
};
